module.exports = __webpack_public_path__ + "svg/flags/Lao People's Democratic Republic.svg";